// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 279 ? "component---src-pages-index-jsx" : chunkId) + "-" + {"279":"f596f0e93827f328e039","452":"0d3b6e0cd21dc5fa9e4e","454":"368ad4917d581bbdaca5","551":"676a981df0f26c5439e3"}[chunkId] + ".js";
};